export { csmRequestsListRoute, csmRequestDetailsRoute } from './routes';
